import QuizFormElements from '@/components/DynamicForm/FormElements/ui-kits/quiz/QuizFormElements';
import FormElements from '@/components/DynamicForm/FormElements/ui-kits/default/FormElements';

export type UiKitsName = 'quiz' | 'default';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type UiKitsType = Record<UiKitsName, Record<string, (props: any) => JSX.Element>>;

const UiKits: UiKitsType = {
	quiz: QuizFormElements,
	default: FormElements,
};

export default UiKits;
